if (!['pre', 'prod'].includes(process.env.VUE_APP_env)) {
  if (window.__POWERED_BY_QIANKUN__) {
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
  }
}

window.$globalProp = window.$globalProp || {
  config: {},
  data: {},
  method: {},
  env: {},
  component: {},
  util: {}
}

import { createApp } from 'vue'
import App from './App.vue'
import { initMicroApp, initGlobalState } from '@/plugin/qiankun'
import { useComponent } from '@/plugin/component'
import { isMicroApp, projectId } from '@/util/env'
import { useBoomComponent } from '@boom/homebrew-component'
// import '@boom/homebrew-component/dist/style.css'

import "./style/global/tailwind.css"
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
import loadMore from './util/selectLoadMore'
import axios from '@/plugin/axios'
import { useRouter } from 'vue-router'

export let app = null

function render(props = {}) {
  app = createApp(App)
  app.directive('loadMore', loadMore)
  const { container } = props
  const { useRouter } = require('@/plugin/router')
  const { useDirective } = require('@/plugin/directive')
  const { useElementPlus } = require('@/plugin/element')
  useRouter(app)
  useDirective(app)
  useElementPlus(app)
  useComponent(app)
  useBoomComponent({
    app,
    axios
  })
  
  app.use(ContextMenu)  
  app.mount(container ? container.querySelector(`#microApp-${projectId}`) : `#microApp-${projectId}`)
}

if (!isMicroApp) {
  render()
  window.$isMicroApp = false
  window.$mainRouter = useRouter()
}

export async function bootstrap(props) {
  await initMicroApp(app, props)
}
export async function mount(props) {
  render(props)
  initGlobalState(app, props)
  app.config.globalProperties.isMicroApp = true
}
export async function unmount() {
  if (app) {
    app.unmount()
    app._container.innerHTML = ''
    app = null
  }
}
